export default __webpack_public_path__ + "static/media/iconDropHere.c61d5c78.svg";